module.exports = __webpack_public_path__ + "static/media/ad-notification-imglink-mockup-below.7ba2d766.png";